import PageHeader from 'components/general/PageHeader/PageHeader';
import { compose, withProps } from 'recompose';
import withQuoteCTA from 'components/hoc/withQuoteCTA';

const DashboardPageHeader = compose(
  withProps({
    title: 'My Dashboard',
    actions: [
      {
        title: 'Edit preferences',
        icon: 'settings',
        to: {
          type: 'PREFERENCES_INTERESTS',
        },
      },
    ],
  }),
  withQuoteCTA(),
)(PageHeader);

export default DashboardPageHeader;

